import {
  type Auswertung,
  type AuswertungAbschnitt,
  type AuswertungReihenfolge,
  type AuswertungZeitraum,
  auswertungReihenfolgeSchema,
  auswertungSchema,
} from '@nac2s/shared'
import { apiFetch } from './client.js'

/** Die Anrufauswertung eines Zeitraums — geprüft gegen den Vertrag. */
export async function ladeAuswertung(zeitraum: AuswertungZeitraum): Promise<Auswertung> {
  return auswertungSchema.parse(await apiFetch(`/api/auswertung?zeitraum=${zeitraum}`))
}

/** Die persönliche Reihenfolge der Anlagen-Abschnitte — je Person gespeichert. */
export async function ladeReihenfolge(): Promise<AuswertungReihenfolge> {
  return auswertungReihenfolgeSchema.parse(await apiFetch('/api/auswertung/reihenfolge'))
}

export async function speichereReihenfolge(
  reihenfolge: readonly AuswertungAbschnitt[],
): Promise<void> {
  await apiFetch('/api/auswertung/reihenfolge', {
    method: 'PUT',
    body: JSON.stringify({ reihenfolge }),
  })
}
